export var timestampToDate = function (_a) {
    var unixNano = _a.unixNano;
    return new Date(unixNano);
};
export var dateToTimestamp = function (d) { return ({ unixNano: d.getTime() }); };
